import type { TallivoProduct } from "./tallivoCatalog";
export function chooseHomepageProducts(products: TallivoProduct[], handles: string[]): TallivoProduct[] {
  const prioritized = handles.map(handle => products.find(p => p.node.handle === handle)).filter((p): p is TallivoProduct => Boolean(p));
  const remaining = products.filter(p => !handles.includes(p.node.handle)).sort((a, b) => Number(b.node.variants.edges.some(v => v.node.availableForSale)) - Number(a.node.variants.edges.some(v => v.node.availableForSale)));
  const seenBrands = new Set(prioritized.map(p => p.brand));
  const diversified = remaining.filter(p => {
    if (!p.brand || seenBrands.has(p.brand)) return false;
    seenBrands.add(p.brand); return true;
  });
  return [...prioritized, ...diversified, ...remaining.filter(p => !diversified.includes(p))].slice(0, 8);
}